.searchBox svg > path {
  color: var(--colors-text-main);
}
